<!--<div-->
<!--  class="flex gap-4 items-center cursor-pointer relative z-[1]">-->
<!--  <div class="rounded-full outline outline-2 outline-white outline-offset-2 border border-black-300 w-4 h-4"></div>-->
<!--  <div class="ig-color-picker-shadow text-nowrap whitespace-nowrap">{{ triggerText }}</div>-->
<!--</div>-->

<!--<div-->
<!--  class="ig-circle absolute w-12 h-12 items-center flex justify-center -left-4 top-[-16px]">-->
<!--  <div class="ig-outer-circle absolute rounded-full w-6 h-6 transition-all" [style.background-color]="color">-->
<!--  </div>-->
<!--</div>-->

<div class=" w-8 h-8 items-center flex justify-center cursor-pointer bg-gray-800 rounded-full"
     [matTooltip]="triggerText">
  <mat-icon class="text-[14px] text-white !w-4 !h-4 !overflow-visible font-normal"
            style="-webkit-text-stroke:0 white">
    border_color
  </mat-icon>
</div>
